// extracted by mini-css-extract-plugin
var _1 = "ErrataView-module_error_list__Hf9cJN";
export { _1 as "error_list" }
